import { alpha } from '@mui/material';

import palette from '@/theme/palette.ts';

export const styles = {
  button: {
    color: palette.text.primary,
  },
  popover: {
    '& .MuiPaper-root': {
      minWidth: '160px',
      borderRadius: '6px',
      marginTop: '10px',
      overflow: 'hidden',
    },
  },
  languageButton: {
    width: '100%',
    justifyContent: 'flex-start',
    padding: '12px 16px',
    borderRadius: 0,
    backgroundColor: 'transparent',
    color: palette.text.primary,
  },
  languageButtonSelected: {
    width: '100%',
    justifyContent: 'flex-start',
    padding: '12px 16px',
    borderRadius: 0,
    backgroundColor: alpha(palette.primary.main, 0.08),
    color: palette.text.primary,
  },
  flagIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '36px',
    height: '36px',
    flexShrink: 0,
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  languageLabel: {
    marginLeft: '10px',
  },
};
